import { render, staticRenderFns } from "./Shipment.vue?vue&type=template&id=5a96dbcd&scoped=true"
import script from "./Shipment.vue?vue&type=script&lang=js"
export * from "./Shipment.vue?vue&type=script&lang=js"
import style0 from "./Shipment.vue?vue&type=style&index=0&id=5a96dbcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a96dbcd",
  null
  
)

export default component.exports